import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaHome, FaChevronRight } from 'react-icons/fa';

const PageHeader = ({ title, breadcrumbs = [], backgroundImage = '/assets/business-colleagues-banner-concept-with-copy-space.jpg' }) => {
  return (
    <section className="relative bg-primary text-white">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src={backgroundImage} 
          alt={title} 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/60"></div>
      </div>
      
      {/* Content */}
      <div className="container-custom relative z-10 py-28 md:py-36">
        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-5xl md:text-6xl font-heading font-semibold text-center mb-8"
        >
          {title}
        </motion.h1>
        
        {/* Breadcrumbs */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="flex items-center justify-center text-sm text-gray-200"
        >
          <Link to="/" className="flex items-center hover:text-secondary transition-colors">
            <FaHome className="mr-2" /> Home
          </Link>
          
          {breadcrumbs.map((crumb, index) => (
            <div key={index} className="flex items-center">
              <FaChevronRight className="mx-2 text-xs opacity-70" />
              {crumb.path ? (
                <Link 
                  to={crumb.path} 
                  className="hover:text-secondary transition-colors"
                >
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-secondary">{crumb.label}</span>
              )}
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default PageHeader; 